module.exports = __webpack_public_path__ + "img/card01.a777c8d3.png";